// extracted by mini-css-extract-plugin
export default {"box":"TippyMenu_box__Sl8l3"};